import { LeftNavMenuItem, LeftNavMenus, LeftNavMenuType } from './types';

export const isMatchingMenuItem = (
  menuItem: LeftNavMenuItem,
  pathName: string,
): boolean => menuItem.path !== '/' && pathName.startsWith(menuItem.path);

export const canShowMenuItem = (menuItem: LeftNavMenuItem): boolean =>
  (menuItem.featureEnabled ?? true) && (menuItem.hasPermission ?? true);

export const getMatchedMenuItem = (
  primaryMenuItems: LeftNavMenus,
  match: string,
): LeftNavMenuItem | undefined =>
  primaryMenuItems.reduce((selectedItem: LeftNavMenuItem | undefined, item) => {
    if (selectedItem != null) {
      return selectedItem;
    }
    if (item.type === LeftNavMenuType.Leaf) {
      if (isMatchingMenuItem(item, match)) {
        return item;
      }
    } else {
      const matchingSubMenu = item.children.find((menuItem) =>
        isMatchingMenuItem(menuItem, match),
      );

      if (matchingSubMenu != null) {
        return matchingSubMenu;
      }
    }

    return selectedItem;
  }, undefined);
